<template>
  <v-text-field
    v-model="idValue"
    :label="label"
    :rules="idRules"
    :hint="hint"
    class="ma-2"
    @input="emit"
  ></v-text-field>
</template>

<script>
export default {
  props: {
    label: {
      default: 'URL',
      type: String,
    },
    required: {
      default: false,
      type: Boolean,
    },
    hint: {
      default: '',
      type: String,
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      idValue: this.value,
      idRules: [
        u => this.required === false || (!!u && this.required === true) || 'Required field',
        u => {
          const pattern = /^([0-9a-zA-Z\-_])+$/;
          return pattern.test(u) || 'Invalid field. The only allowed characters are [0-9a-zA-Z-_].';
        },
      ],
    };
  },
  watch: {
    value(v) {
      this.idValue = v;
    },
  },
  methods: {
    emit() {
      this.$emit('input', this.idValue);
    },
  },
};
</script>
